<template>
  <StencilsTable :stencils="stencils" :sites="[site]" :sites-status="siteStatus" :plan="plan" />
</template>

<script>
import { computed, onMounted, ref } from "@vue/composition-api";
import StencilsTable from "@/components/smart/tables/StencilsTable";
import store from "@/store";

export default {
  name: "SiteStencilsPage",
  components: {
    StencilsTable,
  },
  setup() {
    const plan = computed(() => store.getters["plans/getItem"]);
    const site = computed(() => store.getters["sites/getItem"]);
    const siteStatus = computed(() => store.getters["sites/getItemStatus"]);
    const stencils = computed(() => ({
      list: store.getters["stencils/getList"],
      status: store.getters["stencils/getListStatus"],
    }));
    const loading = ref(true);

    onMounted(() => {
      store.dispatch("stencils/getList", { siteId: site.value.id }).finally(() => {
        loading.value = false;
      });
    });

    return {
      plan,
      site,
      siteStatus,
      stencils,
    };
  },
};
</script>
